__turbopack_context__.v({
  "actions": "contactPage-module-scss-module__1NQv4a__actions",
  "card": "contactPage-module-scss-module__1NQv4a__card",
  "cardCopy": "contactPage-module-scss-module__1NQv4a__cardCopy",
  "cardIcon": "contactPage-module-scss-module__1NQv4a__cardIcon",
  "cardLink": "contactPage-module-scss-module__1NQv4a__cardLink",
  "cardTitle": "contactPage-module-scss-module__1NQv4a__cardTitle",
  "channels": "contactPage-module-scss-module__1NQv4a__channels",
  "content": "contactPage-module-scss-module__1NQv4a__content",
  "disclaimer": "contactPage-module-scss-module__1NQv4a__disclaimer",
  "form": "contactPage-module-scss-module__1NQv4a__form",
  "formSubtitle": "contactPage-module-scss-module__1NQv4a__formSubtitle",
  "formTitle": "contactPage-module-scss-module__1NQv4a__formTitle",
  "intro": "contactPage-module-scss-module__1NQv4a__intro",
  "row": "contactPage-module-scss-module__1NQv4a__row",
  "rowSplit": "contactPage-module-scss-module__1NQv4a__rowSplit",
  "status": "contactPage-module-scss-module__1NQv4a__status",
  "statusError": "contactPage-module-scss-module__1NQv4a__statusError",
  "statusSuccess": "contactPage-module-scss-module__1NQv4a__statusSuccess",
});
